import React from "react";
import { Loading } from "../../../../common";
import CreateLocation from "./CreateLocation";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../../../context";
import useLocation from "../../../../../hooks/useLocation";
import { Sync } from "../../../../../api";

const EditLocation = () => {
  let navigate = useNavigate();
  const { business, user } = useAuthContext();

  const { isLoading, location } = useLocation(user);

  const handleSave = () => {
    Sync(user.username);
    // if (state?.isPos) navigate(-1);
    // navigate("/customers", {
    //   state: {
    //     isArchived: customer._raw.archive,
    //   },
    // });
  };

  return isLoading ? (
    <Loading />
  ) : (
    <>
      <CreateLocation location={location} />
    </>
  );
};

export default EditLocation;
